import Vue from 'vue';
import Vuex from 'vuex';

import analytics from './modules/analytics';
import cards from './modules/cards';
import dailyCards from './modules/dailyCards';
import device from './modules/device';
import favorites from './modules/favorites';
import strings from './modules/strings';
import sw from './modules/sw';
import ui from './modules/ui';
import user from './modules/user';

Vue.use(Vuex);


const store = new Vuex.Store({
  modules: {
    analytics,
    cards,
    dailyCards,
    device,
    favorites,
    strings,
    sw,
    ui,
    user,
  },
  strict: process.env.NODE_ENV !== 'production',
});

store.dispatch('user/init');
store.dispatch('strings/init');
store.dispatch('cards/init');
store.dispatch('device/init');

export default store;


// Template for modules:


// /*

//   STATE

//  */

// const state = {

// };


// /*

//   GETTERS

//  */

// const getters = {
//   exampleGetter: state => { },
// };


// /*

//   ACTIONS

//  */

// const actions = {
//   exampleAction({ commit, dispatch, state, getters, rootState, rootGetters }, otherParams) { },
// };


// /*

//   MUTATIONS

//  */

// const mutations = {
//   exampleMutation(state, data) {
//     state.property = data;
//   },
// };


// export default {
//   namespaced: true,
//   state,
//   getters,
//   actions,
//   mutations,
// };
